<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Documentos por pagar y pagados
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Cuenta Corriente Proveedor</span>
      <span> /</span>
      <span>Documentos por pagar y pagados </span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body align-items-center">
        <div class="col d-flex flex-column" style="max-width: 150px;">
          <!-- Material checked -->
          <div class="form-check">
            <input type="radio" class="form-check-input" id="rbVistaResumen" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_RESUMEN" />
            <label class="form-check-label" for="rbVistaResumen">Resumen</label>
          </div>
          <!-- Material unchecked -->
          <div class="form-check">
            <input type="radio" class="form-check-input" id="rbVistaDetalle" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_DETALLE" />
            <label class="form-check-label" for="rbVistaDetalle">Detalle</label>
          </div>
        </div>
        <div class="col" style="max-width: 150px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
              formControlName="fechaDesde"></mdb-date-picker>
            <label for="fechaDesde">Desde</label>
            <div *ngIf="
              formHeader.get('fechaDesde').invalid &&
              (formHeader.get('fechaDesde').dirty ||
              formHeader.get('fechaDesde').touched)
            ">
              <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">Ingrese fecha
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 150px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Hasta'" required
              formControlName="fechaHasta"></mdb-date-picker>
            <label for="fechaHasta">Hasta</label>
            <div *ngIf="
              formHeader.get('fechaHasta').invalid &&
              (formHeader.get('fechaHasta').dirty ||
              formHeader.get('fechaHasta').touched)
            ">
              <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">Ingrese fecha
              </mdb-error>
            </div>
          </div>
        </div>
        <div [ngClass]="{'col': true, disabledContent: !enableProveedorInputs}" style="max-width: 150px">
          <div class="md-form">
            <input value="" type="text" class="form-control" placeholder="" required formControlName="rut" formatRut />
            <label for="rutproveedor">RUT Proveedor</label>
            <!-- <div *ngIf="
                    formHeader.get('rut').invalid &&
                    (formHeader.get('rut').dirty ||
                    formHeader.get('rut').touched)
                  ">
                  <mdb-error *ngIf="formHeader.get('rut').hasError('required')">Ingrese Proveedor
                  </mdb-error>
                </div> -->
          </div>
        </div>
        <div [ngClass]="{'col d-flex': true, disabledContent: !enableProveedorInputs}" style="max-width: 300px">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="abrirModalSeleccionarProveedor()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" *ngIf="proveedorSeleccionado" style="display: contents;">
            {{ proveedorSeleccionado.nombre }}
          </h6>
        </div>

        <div class="col" style="max-width: 200px">
          <div class="md-form">
            <mdb-select label="Tipo de Doc." [options]="optionsTipoDoc" [multiple]="true" placeholder="Tipo de Doc."
              formControlName="listaTipoDoc" [filterEnabled]="true"></mdb-select>
          </div>
        </div>
        <div class="col" style="max-width: 160px"
          [ngStyle]="{'visibility': formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE? 'visible' : 'hidden'}">
          <mdb-checkbox formControlName="doc_por_pagar">Dcto. Por pagar</mdb-checkbox>
        </div>
        <div class="col" style="max-width: 160px"
          [ngStyle]="{'visibility': formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE? 'visible' : 'hidden'}">
          <mdb-checkbox formControlName="doc_pagados">Dcto. Pagados</mdb-checkbox>
        </div>
      </div>

    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer  justify-content-end" style="border-top: 1px solid #dee2e6">
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="limpiarfiltros()">
        <mdb-icon fas icon="broom"></mdb-icon>
        Limpiar
      </button>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<!-- INICIO RESUMEN -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="resumen_listaMovimientos != null">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">RUT</th>
            <th scope="col">Proveedor</th>
            <th scope="col" class="">Monto</th>
            <th scope="col" class="">Abono</th>
            <th scope="col" class="">Saldo</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="resumen_loading">
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
          <tr *ngIf="!resumen_loading && resumen_listaMovimientos?.length === 0">
            <td colspan="100%" style="text-align: center">
              No se encontró información
            </td>
          </tr>
          <tr>
          <tr *ngFor="let reg of resumen_listaMovimientos">
            <td>{{reg.rutFormato | rut}}</td>
            <td>{{reg.razonSocialCliente}}</td>
            <td class="">{{reg.monto | numerico}}</td>
            <td class="">{{reg.abono | numerico}}</td>
            <td class="">{{reg.saldo | numerico}}</td>
          </tr>
        </tbody>

      </table>

      <div class="table-responsive" *ngIf="resumen_listaMovimientos?.length > 0">
        <table class="table table-striped table-hover table-sm align-middle">
          <tbody style="text-align:right;">
            <tr>
              <td class="col-8" style="padding-right: 4%;">
                <span style="font-weight: bold; font-size: 15px;">Total Monto: </span>
                <span>$ {{resumen_totales.total_monto | numerico}}</span>
              </td>
              <td class="col" style="width: 10%;">
                <span style="font-weight: bold; font-size: 15px;">Total Pago: </span>
                <span>$ {{resumen_totales.total_pago | numerico}}</span>
              </td>
              <td class="col" style="padding-right: 11%;">
                <span style="font-weight: bold; font-size: 15px;">Total Saldo: </span>
                <span>$ {{resumen_totales.total_saldo | numerico}}</span>
              </td>
          </tbody>
        </table>
      </div>
      <app-pagination [context]="resumen_paginationContext" (onPageChange)="resumenOnPageChange($event)"
        *ngIf="resumen_listaMovimientos?.length > 0"></app-pagination>
    </div>


    <!-- INICIO DETALLE -->
    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="detalle_listaMovimientos != null">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">RUT</th>
            <th scope="col">Proveedor</th>
            <th scope="col">Tipo</th>
            <th scope="col">Nro. Doc.</th>
            <th scope="col">Emisión</th>
            <th scope="col">Vencimiento</th>
            <th scope="col" class="text-right">Fecha Abono</th>
            <th scope="col" class="text-right">Monto</th>
            <th scope="col" class="text-right">Abono</th>
            <th scope="col" class="text-right">Saldo doc.</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="detalle_loading">
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
          <tr *ngIf="!detalle_loading && detalle_listaMovimientos?.length === 0">
            <td colspan="100%" style="text-align: center">
              No se encontró información
            </td>
          </tr>
          <tr>
          <tr *ngFor="let reg of detalle_listaMovimientos">
            <td>{{reg.rutFormato | rut}}</td>
            <td>{{reg.razonSocialCliente}}</td>
            <td>{{reg.documento}}</td>
            <td>{{reg.folio}}</td>
            <td>{{reg.fecha_emision | fecha}}</td>
            <td>{{reg.fechaVencimientoDocto | fecha}}</td>
            <td class="text-right">{{reg.fecha_abono | fecha}}</td>
            <td class="text-right">{{reg.monto | numerico}}</td>
            <td class="text-right">{{reg.abono | numerico}}</td>
            <td class="text-right">{{reg.saldo | numerico}}</td>
          </tr>
        </tbody>

      </table>
      <div class="table-responsive" *ngIf="detalle_listaMovimientos?.length > 0">
        <table class="table table-striped table-hover table-sm align-middle">
          <tbody style="text-align:right;">
            <tr>
              <td class="col">
                <span style="font-weight: bold; font-size: 15px;">Total Monto: </span>
                <span>$ {{detalle_totales.total_monto | numerico}}</span>
              </td>
              <td class="col">
                <span style="font-weight: bold; font-size: 15px;">Total Abono: </span>
                <span>$ {{detalle_totales.total_pago | numerico}}</span>
              </td>
              <td class="col">
                <span style="font-weight: bold; font-size: 15px;">Total Saldo: </span>
                <span>$ {{detalle_totales.total_saldo | numerico}}</span>
              </td>
          </tbody>
        </table>

        <app-pagination [context]="detalle_paginationContext" (onPageChange)="detalleOnPageChange($event)"
          *ngIf="detalle_listaMovimientos?.length > 0"></app-pagination>
      </div>

    </div>
  </div>


</div>



<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN && resumen_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="resumenDownloadExcelPdf('XLS')">
      Excel
    </button>
    <!-- <button mdbBtn type="button" color="success" mdbWavesEffect (click)="DownloadPDF()">
          PDF
      </button> -->
  </div>
</div>
<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE && detalle_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="detalleDownloadExcelPdf('XLS')">
      Excel
    </button>
    <!-- <button mdbBtn type="button" color="success" mdbWavesEffect (click)="DownloadPDF()">
          PDF
      </button> -->
  </div>
</div>


<!-- MODAL seleccionarProveedor -->
<app-modal-seleccionar-proveedor [multiple]="false" (onSelect)="onProveedorSeleccionado($event)" queryType="ONLY_RUT"
  showInfoProveedorInactivoBloqueado="true" (onNotFound)="onProveedorNoEncontrado()">
</app-modal-seleccionar-proveedor>
